import intersect from '@turf/intersect';
import toTurf from './toTurf.js';
import fromTurf from './fromTurf.js';
import GeoJSON from 'ol/format/GeoJSON';

export default function getIntersectTurf(feat1, feat2, mapProjection) {
  const formatGeo = new GeoJSON();
  const turfFeat1 = toTurf(feat1, mapProjection, formatGeo);
  const turfFeat2 = toTurf(feat2, mapProjection, formatGeo);

  const intersection = intersect(turfFeat2, turfFeat1);
  if (!intersection) return null;

  return fromTurf(intersection, mapProjection, formatGeo);
};
